import React, { Component } from 'react';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Label } from 'reactstrap';
import CSVIcon from '../Images/csv-ico.png';
import DepartmentFile from '../Resources/Example of Departments.csv';
import Checkbox from '@material-ui/core/Checkbox';
import { Redirect } from 'react-router-dom';
import DepartmentService from '../Services/Department/departmentService';
import { css } from 'react-emotion';
import Radio from '@material-ui/core/Radio';
// First way to import
import { ClipLoader } from 'react-spinners';
var base64 = require('base-64');

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
const scrollTable = {
    'height': '100px',
    'overflowY': 'scroll'
}

class DepartmentImportFile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            DepartmentList: { pennding: false, value: [] },
            DepartmentUpList: { pennding: false, value: [] },
            HeadersList: [],
            error: null,
            checkboxOptions: [],
            CompanyCode: "",
            Selected: false,
            loading: false,
            AddButton: "",
            selectedValue: '2',
            Headers: false,
            HDepartmentCode: false,
            HDepartmentName: false,
            UploadFileName: "Choose File",
            isAutenticated: true
        };
        // this.handleData = this.handleData.bind(this);
        this.SelectedAll = this.SelectedAll.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    handleData(e) {
        var uploadedFile = e.target.files[0];
        var name = e.target.files[0] ? e.target.files[0].name : "Choose File";
        var extFile = e.target.files[0].name.split('.').pop();

        this.setState({
            DepartmentUpList: { pennding: true, value: [] },
            HeadersList: [],
            Headers: false
        });
        if (uploadedFile) {
            if (extFile.toUpperCase() !== "CSV") {
                toast.error("File has to be a .CSV!", {
                    className: {
                        opacity: 0.8
                    }
                });
                return false;
            }
            let reader = new FileReader();
            reader.onload = (progressEvent) => {
                //let target = progressEvent.target; 
                //let result = target.result;               
                var base64result = reader.result.split(',')[1];
                var encoded = base64.decode(base64result);
                var data = encoded.split('\n');
                var DataList = [];
                data.forEach(element => {
                    DataList.push(element.split(','));
                });
                //console.log(DataList)

                var DepartmentName = "";
                var DepartmentCode = "";
                DataList[0].forEach(function (element) {

                    if (element.replace(/\s/g, "").toUpperCase() === "DEPARTMENTCODE") {

                        DepartmentCode = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "DEPARTMENTNAME") {

                        DepartmentName = element;
                    }
                });
                this.setState({
                    DepartmentUpList: { pennding: true, value: DataList },
                    HeadersList: DataList[0],
                    Headers: true,
                    UploadFileName: name,
                    HDepartmentName: { value: DepartmentName, label: DepartmentName },
                    HDepartmentCode: { value: DepartmentCode, label: DepartmentCode },
                });
            };
            reader.readAsDataURL(uploadedFile);
        } else {
            this.setState({
                DepartmentUpList: { pennding: true, value: [] },
                HeadersList: [],
                Headers: true,
                UploadFileName: "Choose File"
            });
        }
    }
    handleHDepartmentCode = event => {
        this.setState({
            HDepartmentCode: event
        });
    }
    handleHDepartmentName = event => {
        console.log(`department name`, event);
        console.table(this.state)
        this.setState({
            HDepartmentName: event
        });
    }
    UploadLocationList(e) {
        e.preventDefault();
        var ActionType = this.state.selectedValue;
        var DataList = this.state.DepartmentUpList.value;
        var HeaderListist = this.state.HeadersList;
        var HeaderDepartmentCode = this.state.HDepartmentCode.value;
        var HeaderDepartmentName = this.state.HDepartmentName.value;
        var Result = [];

        var positionDepartmentCode = HeaderListist.indexOf(HeaderDepartmentCode);
        var positionDepartmentName = HeaderListist.indexOf(HeaderDepartmentName);

        if (positionDepartmentCode === -1) {
            toast.error("Department Code field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (positionDepartmentName === -1) {
            toast.error("Department Name field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        for (var i = 1; i < (DataList.length - 1); i++) {
            if (DataList[i] !== "") {
                Result.push({ DEPARTMENT_CODE: DataList[i][positionDepartmentCode], DEPARTMENT_NAME: DataList[i][positionDepartmentName] });
            }
        }
        if (DataList === "" || DataList === null || DataList === undefined || DataList.length === 0) {

            toast.error("You must to select a File!", {
                className: {
                    opacity: 0.8
                }
            });
        } else {

            if (this.props.CompanyCode && DataList) {
                this.setState({
                    DepartmentList: { pennding: true, value: [] }
                });

                var ListResult = DepartmentService.getDepartmentListResult(this.props.CompanyCode, Result, ActionType);
                var that = this;
                ListResult.then(function (data) {
                    if (data.status === 200) {
                        that.setState({
                            DepartmentList: { pennding: false, value: data.data },
                            checkboxOptions: [],
                        });
                    }
                }).catch((error) => {

                    that.setState({
                        DepartmentList: { pennding: false, value: [] },
                        checkboxOptions: [],
                    });
                    if (error.response) {
                        if (error && error.response && error.response.data.Message === "500") {
                            toast.error("Error Data Base(Error: 500)", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NoDB") {
                            toast.error("Company Code dosen't exist!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NotReseller") {
                            toast.error("This User does not have permission!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data.Message === "400") {
                            toast.error("API Error for Reseller", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error.response.status === 401) {
                            sessionStorage.setItem("user", '');
                            sessionStorage.setItem("token", '');
                            sessionStorage.setItem("rol", '');
                            sessionStorage.setItem("email", '');
                            sessionStorage.clear();
                            this.setState({ isAutenticated: false },
                                () => {
                                    this.forceUpdate();
                                })
                        }
                    } else {
                        toast.error("Code Error", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    }
                });
            }
        }
    }
    handleChange = event => {
        this.setState({
            selectedValue: event.target.value,
            DepartmentList: { pennding: false, value: [] }
        });
    }
    onChange(e, code) {

        const options = this.state.checkboxOptions
        let index

        if (!options.find(x => x === code)) {
            options.push(code)
        } else {
            index = options.indexOf(code)
            options.splice(index, 1)
        }
        this.setState({ checkboxOptions: options }, console.log())
    }
    SelectedAll(e) {
        if (e.target.checked) {
            let optionChecked = [];
            this.state.DepartmentList.value.forEach(l => {
                if (l.AVAILABLE)
                    optionChecked.push(l.DEPARTMENT_CODE);
            })
            this.setState({ checkboxOptions: optionChecked })
        } else {
            this.setState({ checkboxOptions: [] })
        }
    }
    SaveDepartmentList(e) {
        e.preventDefault();
        var CheckboxList = this.state.checkboxOptions;
        var email = sessionStorage.getItem('email');
        var ActionType = this.state.selectedValue;
        var result = [];
        var that = this;

        that.setState({
            loading: true,
            AddButton: "disabled"
        });
        if (CheckboxList.length === 0 || ActionType === "" || ActionType === undefined || ActionType === null) {
            toast.error("You must to select a Department and Option Rows!", {
                className: {
                    opacity: 0.8
                }
            });
            that.setState({
                loading: false,
                AddButton: ""
            });
        } else {
            CheckboxList.forEach(l => {
                var department = this.state.DepartmentList.value.find(x => x.DEPARTMENT_CODE === l);
                result.push(department);
            })
            var DataResult = DepartmentService.SaveDepartment(this.props.CompanyCode, result, ActionType, email);
            DataResult.then(function (data) {
                if (data.data === "OK") {
                    that.setState({
                        loading: false,
                        DepartmentList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.success("Departments Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.data === "InUse") {
                    that.setState({
                        loading: false,
                        DepartmentList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("Department Code in Use!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.statusText === "AuditError") {
                    that.setState({
                        loading: false,
                        DepartmentList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("No Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.statusText === "No") {
                    that.setState({
                        loading: false,
                        DepartmentList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("No Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }
            }).catch((error) => {
                that.setState({
                    loading: false,
                    DepartmentList: { pennding: false, value: [] },
                    checkboxOptions: [],
                    AddButton: "",
                    CompanyCode: ""
                });
                if (error.response) {
                    if (error && error.response && error.response.data.Message === "500") {
                        toast.error("Error Data Base(Error: 500)", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data === "NoDB") {
                        toast.error("Company Code dosen't exist!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data === "NotReseller") {
                        toast.error("This User does not have permission!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data.Message === "400") {
                        toast.error("API Error for Reseller", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error.response.status === 401) {
                        sessionStorage.setItem("user", '');
                        sessionStorage.setItem("token", '');
                        sessionStorage.setItem("rol", '');
                        sessionStorage.setItem("email", '');
                        sessionStorage.clear();
                        this.setState({ isAutenticated: false },
                            () => {
                                this.forceUpdate();
                            })
                    }
                } else {
                    toast.error("Code Error", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }
            });
        }
    }
    changeName(e) {
        //alert(e.target.value)
        var str = e.target.value;
        var res = str.substring(12)
        var extention = res.split('.').pop();

        if (extention.toUpperCase() === "CSV") {
            this.setState({
                FileName: res
            });
        } else {
            this.setState({
                FileName: "CHOOSE A FILE",
                DepartmentUpList: { pennding: false, value: [] },
            });
            toast.error("File Error!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        return true;
    }
    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'} />)
        }
        let optionItemsHeaders = this.state.HeadersList.map((item, index) => {
            return { value: item, label: item }
        });
        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar />
                    <div className="card-body">
                        <div className="row">
                            <div className="col-2">
                                <h4><span className="badge badge-info">Departments</span></h4>
                            </div>
                            <div className="col-2 offset-10">
                                <Label for="exampleFile" style={{ 'fontWeight': 'bold' }}>Download Sample</Label>
                                <a href={DepartmentFile} download="Example of Departments.CSV"><img src={CSVIcon} title="NotImage" alt="" width='40px' /></a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3 offset-2">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div className="upload-btn-wrapper" key={Math.random() * 1200000}>
                                        <button style={{ 'width': '100%', 'backgroundColor': '#00C851', 'marginLeft': '0px' }} onClick={(e) => this.fileInput.click(e)} className="btn btn-primary">{this.state.UploadFileName}</button>
                                        <input ref={input => this.fileInput = input} type="file" name="myfile" style={{ 'display': 'none' }} onChange={(event) => { this.handleData(event) }} />
                                    </div>
                                }
                            </div>
                            <div className="col-2">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div >
                                        <label>Delete Rows in Table</label>
                                        <Radio
                                            checked={this.state.selectedValue === '1'}
                                            onChange={this.handleChange}
                                            value="1"
                                            name="radio-button-demo"
                                            aria-label="A"
                                            color="primary"
                                        />
                                    </div>
                                }

                            </div>
                            <div className="col-3">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div >
                                        <label>Appends Rows in Table</label>
                                        <Radio
                                            checked={this.state.selectedValue === '2'}
                                            onChange={this.handleChange}
                                            value="2"
                                            name="radio-button-demo"
                                            aria-label="B"
                                            color="primary"
                                        />
                                    </div>
                                }
                            </div>

                        </div>
                        <br /> <br />
                        {
                            this.state.Headers
                            &&
                            <div className="row">
                                <div className="col-2 offset-3">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Department Code(<span style={{ color: 'red' }}>*</span>):</label>
                                        <Select
                                            value={this.state.HDepartmentCode}
                                            onChange={this.handleHDepartmentCode}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Department Name(<span style={{ color: 'red' }}>*</span>):</label>
                                        <Select
                                            value={this.state.HDepartmentName}
                                            onChange={this.handleHDepartmentName}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group" style={{ paddingTop: '28px' }}>
                                        <button className="btn btn-info" onClick={(e) => { this.UploadLocationList(e) }} >Preview</button>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                {
                    (this.state.DepartmentList.pennding
                        && <span className="loader"></span>)
                    ||
                    (this.state.DepartmentList.value.length > 0
                        && <div className="card Logs">
                            <div className="card-body">
                                <div className="row" style={{ 'height': '350px', 'overflow': 'auto' }}>
                                    <table className="table table-hover table-striped table-sm" >
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    <Checkbox
                                                        style={{ width: 25, height: 25 }}
                                                        // checked={this.state.Selected}
                                                        onChange={this.SelectedAll}
                                                        //value={this.state.checkboxOptions}
                                                        color="primary"
                                                    />
                                                </th>
                                                <th scope="col">Department Code</th>
                                                <th scope="col">Department Name</th>
                                            </tr>
                                        </thead>
                                        <tbody style={scrollTable}>
                                            {
                                                (this.state.DepartmentList.pennding
                                                    && <tr><td colSpan="7"><span className="loader"></span></td></tr>)
                                                || this.state.DepartmentList.value.map((item, index) => {

                                                    return <tr key={index}>
                                                        <td>
                                                            {
                                                                (item.AVAILABLE
                                                                    &&
                                                                    <Checkbox
                                                                        style={{ width: 25, height: 25 }}
                                                                        checked={this.state.checkboxOptions.find(x => x === item.DEPARTMENT_CODE) !== undefined}
                                                                        onChange={(e) => this.onChange(e, item.DEPARTMENT_CODE)}
                                                                        value={item.DEPARTMENT_CODE}
                                                                        color="primary"
                                                                    />)
                                                                ||
                                                                <span className="badge badge-danger">{item.AVAILABLE_MSG}</span>
                                                            }

                                                        </td>
                                                        <td>{item.DEPARTMENT_CODE}</td>
                                                        <td>{item.DEPARTMENT_NAME}</td>
                                                    </tr>;
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-2 offset-10">
                                        <ClipLoader
                                            className={override}
                                            sizeUnit={"px"}
                                            size={30}
                                            color={'#33B5E5'}
                                            loading={this.state.loading}
                                        />
                                        <button disabled={this.state.AddButton} className="btn btn-info" onClick={(e) => { this.SaveDepartmentList(e) }} >Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>)
                }
            </div>
        );
    }
}
export default DepartmentImportFile;


// WEBPACK FOOTER //
// ./src/ImportFile/DepartmentsImportfile.jsx